module.exports = __webpack_public_path__ + "img/custom-icon.6774bff0.png";